import React from "react";
import { useLoadWishlistItem } from "theme/modules/Wishlist/WishlistProvider/WishlistProvider";
import { useLoadWishlist } from "../WishlistProvider/WishlistProvider";

const IsProductInWishlist = ({ _BaseComponent: BaseComponent, ...props }) => {
  const { isInWishlist, wishlistItem } = useLoadWishlistItem(props.sku);
  const { wishlist } = useLoadWishlist();

  return (
    <BaseComponent
      {...props}
      isInWishlist={isInWishlist}
      wishlistItem={wishlistItem}
      shouldRefetchWishlist={!wishlist?.id}
    />
  );
};
const IsProductInWishlistHOC = (BaseComponent) => (props) =>
  <IsProductInWishlist {...props} _BaseComponent={BaseComponent} />;
export default () => IsProductInWishlistHOC;
